import { render, staticRenderFns } from "./fastNewsControl.vue?vue&type=template&id=071f21ac&scoped=true"
import script from "./fastNewsControl.vue?vue&type=script&lang=js"
export * from "./fastNewsControl.vue?vue&type=script&lang=js"
import style0 from "./fastNewsControl.vue?vue&type=style&index=0&id=071f21ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f21ac",
  null
  
)

export default component.exports